String.prototype.isEmpty = function () {
  return this.length === 0
}

String.prototype.toInt = function () {
  return parseInt(this)
}
